export enum OnBoardStep {
  DOCUMENT_CAPTURE=1,
  SECONDARY_DOCUMENT_CAPTURE,
  // REVIEW_DETAILS,
  // FACE_CAPTURE,
  // PASSIVE_LIVENESS,
  SMILE_LIVENESS,
  // MAGNIFEYE_LIVENESS,
  RESULTS,
}


export enum PrimaryDocumentCaptureStep{
  INSTRUCTION = 1,
  FRONT_CAPTURE,
  BACK_CAPTURE,
  ON_SUCCESS,
  ON_FAILURE,
  ON_BARCODE_DETECTION_FAILURE
}

export enum Assertion {
  PASSIVE = "NONE",
  SMILE = "SMILE",
  NEUTRAL_SMILE = "NEUTRAL",
}

export enum EvaluateLiveness{
  MAGNIFEYE_LIVENESS="MAGNIFEYE_LIVENESS",
  PASSIVE_LIVENESS="PASSIVE_LIVENESS",
  SMILE_LIVENESS="SMILE_LIVENESS"
}

export interface ICaptureTimestamp{
  documentFront:number;
  documentBack:number;
  secondaryDocument:number;
  selfie:number;
  passiveLiveness:number;
  neutral: number;
  smileLiveness:number;
}

export interface IImageFormat{
  documentFront:string;
  documentBack:string;
  secondaryDocument:string;
  selfie:string;
  passiveLiveness:string;
  neutral:string;
  smileLiveness:string
}

export interface IPrimaryDocumentImages{
  frontImage: string;
  backImage: string;
}

export interface IImageQuality extends ICaptureTimestamp{
}

export enum SecondaryDocumentCaptureStep{
  SELECT=1,
  CAPTURE,
  ON_FAILURE,
  ON_SUCCESS
}

export enum LivenessCaptureStep{
  INSTRUCTION=1,
  PASSIVE_LIVENESS,
  ACTIVE_LIVENESS,
  ON_FAILURE,
  ON_SUCCESS,
  UPLOAD_PHONE_NUMBER,
  /**
   * The selfie was recorded but the automated liveness check did not confirm it.
   *
   * There is no retry left at this point, so the journey continues either way —
   * but it used to continue through ON_SUCCESS, which told the applicant "we have
   * captured your selfie" and said nothing about the check having failed. Appended
   * rather than inserted so the existing values keep their numbers.
   */
  ON_UNCONFIRMED
}

export enum ResultsStep{
  REVIEW_DETAILS = 1,
  SUCCESSFULL_SUBMISSION
}


export enum FAILURES {
  PRIMARY_DOCUMENT_CAPTURE = "primarydocument.capture.errorbadge",
  SECONDARY_DOCUMENT_CAPTURE = "secondarydocument.capture.errorbadge",
  LIVENESS_CAPTURE = "liveness.capture.errorbadge",
}
